import { readXlsxFile } from "./xlsx"

export const StallColors = {
  "A": "#E6BBD0",
  "B": "#CF9AB8",
  "C": "#DAAF80",
  "D": "#9EACCB",
  "E": "#9AC996",
  "F": "#E8B29B",
  "Ｆ": "#E8B29B",
  "G": "#8BB8B2",
  "H": "#E0A7A5",
  "I": "#B6A0C9",
  "J": "#9BCA96",
  "K": "#E08D8A",
}

export type StallData = {
  "ID": string,
  "エリアID": keyof typeof StallColors,
  "No.": string,
  "エリア名": string,
  "場所": string | undefined,
  "団体名": string,
  "企画名": string,
  "概要": string,
  "画像ID": string,
}

export function toStall(area: string, data: any) {
  const id = data["模擬店大賞番号"]

  let areaId: keyof typeof StallColors, no: string
  let place: string | undefined = undefined
  if (0 < id.indexOf("・")) {
    [place, areaId, no] = id.split(/・|-/)
  } else {
    [areaId, no] = id.split("-")
  }

  return {
    "ID": id,
    "エリアID": areaId,
    "No.": no,
    "エリア名": area,
    "場所": place,
    "団体名": data["団体名"],
    "企画名": data["企画名_参照"],
    "概要": data["説明_参照"],
    "画像ID": data["画像ID_参照"],
  } as StallData
}

export async function fetchStalls(area: string) {
  const records = await readXlsxFile(`/data/stall/${area}.xlsx`, "シート1")
  const stalls = records.map((record) => toStall(area, record))
  return stalls
}

export async function fetchAllStalls() {
  const files = import.meta.glob(
    "~/public/data/stall/*",
    { eager: true, query: '?url', import: "default" },
  )

  const stalls = (await Promise.all(Object.keys(files).map(filepath => {
    const filename = filepath.split('/').slice(-1)[0]!.replace('.xlsx', '')
    return fetchStalls(filename)
  }))).flat()

  return stalls
}
